<template>
  <div class="login-page">
    <div class="login-wrap">
      <div class="title">会员登录</div>
      <form onsubmit="return false">
        <div class="login-input-wrap">
          <input class="login-input" v-model.trim="info.account" type="text" placeholder="账号">
        </div>
        <div class="login-input-wrap">
          <input class="login-input" v-model="info.password" type="password" placeholder="密码">
        </div>
        <div class="login-input-wrap">
          <button class="login-btn" @click="login">登录</button>
        </div>
      </form>
      <div class="msg"></div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      info: {
        account: '',
        password: ''
      }
    }
  },
  methods: {
    login () {
      const that = this
      if (this.info.account === '') {
        that.$message.error('账号不能为空')
      } else if (this.info.password === '') {
        that.$message.error('还未填写密码')
      } else {
        that.axios.post('login', this.info).then(function (resp) {
          if (resp.data.code === 0) {
            that.$message.success('成功登录')
            sessionStorage.setItem('token', resp.data.token)
            const user = JSON.stringify(resp.data.user)
            sessionStorage.setItem('user', user)
            that.$store.commit('updateUserInfo', { user: resp.data.user })
            that.$router.push({ name: 'MyZone', params: { id: resp.data.user.id } })
          } else {
            that.$message.error('发生错误')
          }
        }).catch(function () {
          that.$notify.error({
            title: '错误',
            message: '系统发生错误，请联系管理员',
            duration: 0
          })
        })
      }
    }
  },
  mounted () {
    console.log('login page mounted')
    sessionStorage.clear()
    this.$store.commit('initUserInfo')
    console.log(sessionStorage.getItem('user'))
  }
}
</script>

<style scoped>
.login-wrap{
  width: 400px;
  margin: 100px auto;
}
.title{
  text-align: left;
  font-size: 17px;
  color: #1b1b1b;
  padding: 10px;
}
.login-input-wrap{
  box-sizing: border-box;
  padding: 10px;
}
.login-input{
  width: 100%;
  padding: 12px;
  border-radius: 3px;
  border-width: 1px;
  letter-spacing: 2px;
}
.login-btn{
  text-align: center;
  width: 100%;
  padding: 12px;
  background-color: #1b1b1b;
  border-radius: 3px;
  color: #fff;
  font-size: 12px;
  cursor: pointer;
}
</style>
